import React from 'react';

export type DataStateTone = 'info' | 'warn' | 'error';

export interface DataStateNoticeProps {
  tone: DataStateTone;
  title: string;
  body?: string;
  action?: { label: string; onClick: () => void };
}

// Written out in full so Tailwind/DaisyUI generate every variant. A class name built at runtime
// ("alert-" + tone) is invisible to the scanner and would render a plain, unstyled alert.
const ALERT_CLASS: Readonly<Record<DataStateTone, string>> = {
  info: 'alert-info',
  warn: 'alert-warning',
  error: 'alert-error',
};

/**
 * A short message about the state of the data: nothing delivered, no access, a failed request.
 * Errors are announced at once (role="alert"); the rest are polite status messages.
 */
const DataStateNotice: React.FC<DataStateNoticeProps> = ({ tone, title, body, action }) => (
  <div role={tone === 'error' ? 'alert' : 'status'} className={`alert ${ALERT_CLASS[tone]} text-sm`}>
    <div>
      <p className="font-bold">{title}</p>
      {body ? <p>{body}</p> : null}
    </div>
    {action ? (
      <button type="button" className="btn btn-sm" onClick={action.onClick}>
        {action.label}
      </button>
    ) : null}
  </div>
);

export default DataStateNotice;
